/**
 * Created by Christof Sander on 01.07.2016.
 */

const utils = require('frontend-controller/lib/utils')

module.exports = {
	extends: [
		'/',
		'base',
		'treesManagement',
		'propertiesForm'
	],

	hooks: {
		postAttach: function($element, options){
			if(this.config.creationMode){
				var serviceID = this.getResourceRegisterContent('serviceID');
				if(serviceID){
					this.fieldToModel('serviceID', serviceID);
				}
			}
			else {
				var userID  	= this.resourceData.data.attributes.userID;
				var scopeRoles  = this.resourceData.data.children.s_services_users_scopeRoles.data;

				// reset dirty fields to prevent unnecessary deletions if necessary
				if(((((this.model.dirtyFields || {}).data || {}).children || {}).s_services_users_scopeRoles || {}).data){
					this.model.dirtyFields.data.children.s_services_users_scopeRoles.data = [];
				}

				// select right user if necessary
				if(userID){
					this.find('templates_userTrees_selectUserTrees', function(treesComponent){
						if(treesComponent.treesReady()){
							treesComponent.selectNodeByID(userID, 'user');
						}
						else {
							treesComponent.config.readyNodeID        = userID;
							treesComponent.config.readyNodeContext   = 'user';
						}
					});
				}
				// select right scopeRoles if necessary
				if(scopeRoles){
					this.find('templates_scopeTrees_selectScopeRoles', function(component){
						component.selectScopeRoles(scopeRoles);
					});
				}
			}
		}
	}
};
